import baseRoute from '../baseRoute';

export type * from './requestModel';

type RouteDefinition = `${typeof baseRoute}/job/${':jobId' | number}/bulk`;

export const ROUTE: RouteDefinition = `${baseRoute}/job/:jobId/bulk`;

export const URL = (jobId: number): RouteDefinition => `${baseRoute}/job/${jobId}/bulk`;
